<template>
  <div>
    <div class="accidents-right-bar">
      <simplebar class="h-100">
        <div class="rightbar-title px-3 py-4 d-flex">
          <h5 class="m-0">Accident Filters</h5>
          <a
            href="javascript:void(0);"
            class="accidents-right-bar-toggle ms-auto"
            @click="$emit('close')"
          >
            <i class="mdi mdi-close noti-icon"></i>
          </a>
        </div>
        <hr class="mt-0" />
        <div class="p-3">
          <h6 class="mb-2">From Date:</h6>
          <div class="input-group mb-3">
            <date-picker
              v-model="filterSelect.datepickervalueFrom"
              :first-day-of-week="1"
              :disabled-date="(date) => date >= new Date()"
              lang="en"
              placeholder="Choose From Date"
            ></date-picker>
          </div>

          <h6 class="mb-2">To Date:</h6>
          <div class="input-group mb-3">
            <date-picker
              v-model="filterSelect.datepickervalueTo"
              :first-day-of-week="1"
              :disabled-date="
                (date) =>
                  date < new Date(filterSelect.datepickervalueFrom) || date >= new Date()
              "
              lang="en"
              placeholder="Choose To Date"
            ></date-picker>
          </div>

          <h6 class="mb-2">Accident ID:</h6>
          <div class="input-group mb-3">
            <input
              v-model="filterSelect.incidentId"
              type="number"
              class="form-control"
              placeholder="Search by Incident ID"
            />
          </div>

          <h6 class="mb-2">Vehicle No:</h6>
          <div class="input-group mb-3">
            <b-form-input
              v-model="filterSelect.filterVehicleNumber"
              class="form-control"
              placeholder="Search by Vehicle No."
              maxlength="10"
            ></b-form-input>
          </div>

          <h6 class="mb-2">Vehicle Class:</h6>
          <div class="input-group mb-3">
            <v-select
              class="col-12 style-chooser"
              v-model="filterSelect.vehicleClass"
              :options="vehicleClassOptions"
              label="class_name"
              :reduce="(category) => category.id"
            ></v-select>
          </div>

          <hr class="mt-0" />
          <b-button
            class="btn btn-success btn-block btn-rounded w-100 mb-2"
            @click="$emit('getFilteredIncidents', JSON.stringify(filterSelect))"
            ><i class="fa fa-check me-2"></i>Filter</b-button
          >
          <b-button
            variant="outline-danger"
            class="btn btn-block btn-rounded w-100"
            @click="resetFilter"
            block
            ><i class="fa fa-times me-2"></i>Reset</b-button
          >
        </div>
      </simplebar>
    </div>
    <!-- Right bar overlay-->
    <div class="accidents-rightbar-overlay"></div>
  </div>
</template>
<script>
import simplebar from "simplebar-vue";
import DatePicker from "vue2-datepicker";
import "../../assets/plugins/range-slider/vue-range-slider.css";
import VueRangeSlider from "../../assets/plugins/range-slider/vue-range-slider";

/**
 * Right sidebar component
 */
export default {
  components: {
    simplebar,
    DatePicker,
    VueRangeSlider,
  },
  props: {
    vehicleClassOptions: Array,
  },
  data() {
    return {
      filterSelect: {
        datepickervalueFrom: null,
        datepickervalueTo: null,
        incidentId: null,
        filterVehicleNumber: null,
        vehicleClass: null,
      },
    };
  },
  methods: {
    resetFilter() {
      this.filterSelect = {
        datepickervalueFrom: null,
        datepickervalueTo: null,
        incidentId: null,
        filterVehicleNumber: null,
        vehicleClass: null,
      };

      this.$emit("resetFilter");
    },
  },
};
</script>
